import React, { Component } from 'react';
import * as moment from 'moment';
import dateToHumanFormat from '../helpers/dateToHuman';
import { setCookie, getCookie, monthTimeout } from '../../../helpers/cookie';
import cinemas from './cinemas';
import TownChoices from '../../town-choices';
// import { render } from 'pug';

class Header extends Component {
  // TODO: Hall string check

  state = {
    townIsOpen: false,
    selectedCity: this.props.cinema.city,
    nameSelectedCinema: this.props.cinema.short_name,
    listCityIsOpen: false, // state for mobile
    cityAlert: false,
  };

  setStateChild = (valueIsOpen, valueSelectedCity, valueCityAlert) => {
    this.setState({
      townIsOpen: valueIsOpen,
      selectedCity: valueSelectedCity,
      cityAlert: valueCityAlert,
    });
  };

  toggleTown = () => {
    if (getCookie('askCity') != moment().format('DD.MM')) {
      setCookie('askCity', `${moment().format('DD.MM')}`, monthTimeout);
    } else {
      setCookie('askCity', 0, monthTimeout);
    }

    this.props.forceUpdate(); // for hide toggle block
  };

  render() {
    const { townIsOpen, listCityIsOpen, selectedCity, cityAlert } = this.state;
    const { name, cinema, user } = this.props;

    const classes = ['town'];
    if (townIsOpen) classes.push('town--open');
    if (listCityIsOpen) classes.push('town--list');

    if (getCookie('askCity') != moment().format('DD.MM')) {
      classes.push('town--ask');
    }

    return (
      <div className="scheme-popup__header">
        <h3 className="heading heading--2">{name}</h3>
        <div className="title-meta">
          <div className="title-meta__item">
            <div className={classes.join(' ')}>
              <button
                className="town__toggler"
                type="button"
                onClick={() => this.toggleTown()}
              >
                <span className="town__sub-txt">{cinema.name}</span>
              </button>

              <div className="town__ask">
                <p>Ваш кинотеатр {this.props.cinema.short_name}?</p>
                <div className="town__buttons">
                  <button
                    type="button"
                    className="btn btn--sm btn--outline"
                    onClick={() => this.setState({ townIsOpen: true })}
                  >
                    Нет
                  </button>
                  <button
                    type="button"
                    className="btn btn--sm"
                    onClick={() => this.toggleTown()}
                  >
                    Да
                  </button>
                </div>
              </div>

              <div
                className={`town-popup-bg ${townIsOpen ? 'is-active' : ''}`}
              />
              {townIsOpen ? (
                <TownChoices
                  position={'header'}
                  townIsOpen={this.state.townIsOpen}
                  cinema={this.props.cinema.city}
                  setStateChild={this.setStateChild}
                />
              ) : null}
            </div>
          </div>
          <span className="title-meta__item">{`Зал ${this.props.hall}`}</span>
          <span className="title-meta__item">
            {dateToHumanFormat(this.props.datetime)}
          </span>
        </div>
        <button
          className="scheme-popup__close"
          type="button"
          onClick={() => {
            setCookie('userChooseInfo', 0, monthTimeout);
          }}
        >
          <svg viewBox="0 0 18 18" width="18" height="18">
            <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z"></path>
          </svg>
        </button>

        {cityAlert && user.phone ? (
          <div className="scheme-box__alerts alerts">
            <div className="alert-item">
              При смене города вам потребуется заново авторизоваться
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Header;
